module.exports = __webpack_public_path__ + "static/media/ad-slide-04.d518d68e.jpg";